import Dictionary from "../Classes/Dictionary";
import { IGrade } from "../Types/IGrade";

type GetColourProps = {
    type: "Evaluate" | "Enquire" | "Improve" | "Develop",
}


export const GetColour = (type : "Evaluate" | "Enquire" | "Improve" | "Develop" | "Generic" | "Red" | "Green" | "Yellow" | "Blue" | "Amber") => {

    const productColours = new Dictionary<string, string>([
        ["Evaluate", "#F0F5F7"],
        ["Enquire", "#F0F5F7"],
        ["Improve", "#F0F5F7"],
        ["Develop", "#F0F5F7"],
        ["Generic", "#F0F5F7"],

        ["Red", "#E25A74"],
        ["Green", "#52BFA2"],
        ["Yellow", "#EAB33C"],
        ["Amber", "#EAB33C"],
        ["Blue", "#24394F"],
        ["Not Set", "#24394F"],
    ]);

    return productColours.tryGetValue(type, undefined);
}

export const GetGradeColour = (type : string) => {

    const productColours = new Dictionary<string, string>([
        ["Red", "#E25A74"],
        ["Green", "#52BFA2"],
        ["Amber", "#EAB33C"],
        ["Blue", "#24394F"],
        ["Not Set", "#efefef"],
    ]);

    return productColours.tryGetValue(type, undefined);
}